import Image from "next/image";

import newChatIcon from "@/assets/icons/chat-new.svg";
import newReportIcon from "@/assets/icons/report-new.svg";
import suggestIcon from "@/assets/icons/suggest-add.svg";
import newReportDisabledIcon from "@/assets/icons/report-new-disabled.svg";
import taskPlusIcon from "@/assets/icons/add-task-white.svg";
import improvementIcon from "@/assets/icons/improvement.svg";

type Props = {
  iconType:
    | "newChat"
    | "newReport"
    | "suggest"
    | "ownerAddTask"
    | "ownerImprovement";
  colorType: "pink" | "pinkBorder" | "blue" | "blueBorder";
  value: string;
  clickHandler: () => void;
  label?: string;
  isAnime?: boolean;
  isAnimeSlow?: boolean;
  isDisabled?: boolean;
  isAutoHidden?: boolean;
};

/* フローティングアクションボタン */
const FaButton: React.FC<Props> = ({
  iconType,
  colorType,
  value,
  clickHandler,
  label,
  isAnime,
  isAnimeSlow,
  isDisabled,
  isAutoHidden
}) => {
  const isSuggestions = iconType === "suggest";
  const textColor =
    colorType === "pink"
      ? "text-white"
      : colorType === "pinkBorder"
        ? "text-[#f45555]"
        : colorType === "blue"
          ? "text-white"
          : "text-[#36AED7]";

  const bgColor =
    colorType === "pink"
      ? "bg-[#f45555]"
      : colorType === "pinkBorder"
        ? "bg-white"
        : colorType === "blue"
          ? "bg-[#36AED7]"
          : "bg-white";

  const borderColor =
    colorType === "pinkBorder"
      ? "border-2 border-[#f45555]"
      : colorType === "blueBorder"
        ? "border-2 border-[#36AED7]"
        : "";

  return (
    <div
      className={
        `relative ${
          isSuggestions ? "bg-[#36AED7]" : bgColor
        } cursor-pointer rounded-full ${
          isDisabled ? "border-2 border-[#BFBFBF]" : borderColor
        } flex h-[7.2rem] w-[7.2rem] flex-col items-center justify-center shadow-[0px_0px_10px_0px_rgba(0,0,0,0.15)] ` +
        (isAnime
          ? `animate__animated ${
              isAutoHidden ? "animate__fadeOutDown" : "animate__fadeInUp"
            } ${isAnimeSlow ? "" : "animate__faster"}`
          : "")
      }
      onClick={clickHandler}
    >
      {/* Newなどのラベル */}
      {label && (
        <div className="absolute -right-[0.75rem] top-0 rounded-[6.1rem] bg-cErrorRed px-[0.6rem] py-[0.2rem] text-[1rem] text-white">
          {label}
        </div>
      )}
      <div className="-mt-4 h-[2.9rem] w-[2.9rem]">
        <Image
          src={
            iconType == "newChat"
              ? newChatIcon
              : isSuggestions
                ? suggestIcon
                : iconType === "ownerAddTask"
                  ? taskPlusIcon
                  : iconType === "ownerImprovement"
                    ? improvementIcon
                    : isDisabled
                      ? newReportDisabledIcon
                      : newReportIcon
          }
          alt={iconType}
        />
      </div>
      <p
        className={`${
          isDisabled
            ? "text-cdisabled"
            : isSuggestions
              ? "text-white"
              : textColor
        } text-sm font-medium`}
      >
        {value}
      </p>
    </div>
  );
};

export default FaButton;
